import { combineReducers } from 'redux';
import Auth from './Auth';
import ConfirmDelivery from './ConfirmDelivery';
import Contract from './Contract';
import Invoice from './Invoice';
import Window from './Window';

export default combineReducers({ Auth, ConfirmDelivery, Contract, Invoice, Window });